// Generated by tools/design-tokens from design/figma. Do not edit.

/** The drawer's palette, in toolbar order. */
export const brushes = [
  { name: 'ink', color: '#282b25' },
  { name: 'graphite', color: '#8a8c82' },
  { name: 'white', color: '#ffffff' },
  { name: 'coral', color: '#fe7859' },
  { name: 'red', color: '#d64532' },
  { name: 'orange', color: '#f2994a' },
  { name: 'sun', color: '#f5c842' },
  { name: 'leaf', color: '#a8c93a' },
  { name: 'green', color: '#3e8e5e' },
  { name: 'sky', color: '#5b9bd5' },
  { name: 'violet', color: '#8466c9' },
  { name: 'brown', color: '#8a5a3b' },
] as const;

export type BrushName = (typeof brushes)[number]['name'];
